import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    marginRight: "8rem",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  menuItem: {
    color: "#ddd",
    marginLeft: "1.5rem",
    overflow: "visible",
    "&:hover": {
      color: "white",
    },
  },
  menuPrincipalItem: {
    color: "#FFFFFFBB",
    "&:hover": {
      color: "#FFF",
    },
  },
  menuPrincipalItemAtivo: {
    color: "#FFF",
  },
  menuPrincipalItemBar: {
    transform: "translate(0, 0.8rem)",
    transition: "background-color 100ms linear",
    [theme.breakpoints.up("md")]: {
      transform: "translate(0, 0.95rem)",
    },
  },
  margin: {
    marginTop: "0.5rem",
  },
}));

export default useStyles;
